import Alpine from "alpinejs";
import { AssistantTranscriptService } from "@src/js/services/assistantTranscriptService";
import { getQueryParam } from "@src/js/utils/http";
Alpine.data("assistantTranscripts", () => ({
    page: 1,
    perPage: 10,
    transcripts: [],
    async init() {
        const queryParam = getQueryParam('shareKey');
        this.transcripts = await AssistantTranscriptService.getAll(queryParam); // replace with your real share key
        console.log("Transcripts loaded:", this.transcripts.length);
    },
    get paginatedData() {
        const start = (this.page - 1) * this.perPage;
        return this.transcripts.slice(start, start + this.perPage);
    },
    get pageCount() {
        return Math.ceil(this.transcripts.length / this.perPage);
    },
}));
